/* eslint-disable no-tabs */
export default class PriorityModel {
  constructor() {
    this.caseId = '';
    this.agentId = '';
    // 案編
    this.displayId = '';
    // 名子
    this.name = '';
    this.memberId = '';
    this.displayId = '';
    this.productId = '';
    this.installmentsNumber = 0;
    this.creditPriceMonth = 0;
    this.totalPrice = 0;
    // 優撥金額
    this.realPrice = 0;
    // 大牌號碼
    this.carId = '';
    this.fileName1 = '';
    this.fileURL1 = '';
    this.fileName2 = '';
    this.fileURL2 = '';
  }
}



// WEBPACK FOOTER //
// ./src/models/PriorityModel.js